<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали тарифного плана
      <router-link class="btn btn-primary" :to="{ name: 'rate-plan-edit', params: { id: rate_plan.id }}">Редактировать информацию</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'rate-plans' }">← Назад к Тарифным планам</router-link>
    </div>

    <div class="row">
      <div class="col-md-6">

        <!-- Name -->
        <div class="form-group">
          <label>Название</label>
          <p>{{ rate_plan.name }}</p>
        </div>

        <!-- Amount -->
        <div class="form-group">
          <label>Тариф в месяц</label>
          <p>{{ toMoney(rate_plan.amount) }}</p>
        </div>

        <!-- Period -->
        <div v-if="false" class="form-group">
          <label>Периодичность (дней)</label>
          <p>{{ rate_plan.period }}</p>
        </div>

        <!-- Start date -->
        <div v-if="false" class="form-group">
          <label>Дата начала</label>
          <p>{{ formatDate(rate_plan.start_date) }}</p>
        </div>

        <!-- End date -->
        <div v-if="false" class="form-group">
          <label>Дата окончания</label>
          <p>{{ formatDate(rate_plan.end_date) }}</p>
        </div>

      </div>
      <div v-if="false" class="col-md-6">

        <!-- Last payment -->
        <div class="form-group">
          <label>Последняя проплата</label>
          <p>{{ formatDate(rate_plan.last_payment) }}</p>
        </div>

        <!-- Next payment -->
        <div class="form-group">
          <label>Следующая проплата</label>
          <p>{{ formatDate(rate_plan.next_payment) }}</p>
        </div>

        <!-- Payments count -->
        <div class="form-group">
          <label>Общее кол-во проплат за период</label>
          <p>{{ rate_plan.payments_count }}</p>
        </div>

        <!-- Total -->
        <div class="form-group">
          <label>Общая сумма за весь период</label>
          <p>{{ toMoney(rate_plan.total) }}</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { getRatePlan } from '@/services/rate_plan.service'
import helpers from '@/helpers'

export default {
  name: 'rate-plan-details',
  data () {
    return {
      rate_plan: {
        id: null,
        name: '',
        amount: '',
        period: '',
        start_date: '',
        end_date: '',
        last_payment: '',
        next_payment: '',
        payments_count: '',
        total: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.rate_plan.id = this.$route.params.id

      getRatePlan(this.rate_plan.id).then((response) => {
        this.rate_plan = response.data
      })
    }
  },
  methods: {
    formatDate: helpers.formatDate,
    toMoney: helpers.toMoney
  }
}
</script>


// WEBPACK FOOTER //
// RatePlanDetails.vue?3b11a2a2